export default function getRoles(obj, key) {
  return Array.isArray(obj.user.roles) && obj.user.roles.includes(key);
}
